import {Component} from '@angular/core';
import {BackendService} from "@app/core/backendService/backend.service";
import {ActivatedRoute} from "@angular/router";
import {Survey} from "@app/shared/models/Survey";
import {CredentialsService} from "@app/core/authentication/credentials.service";
import {PointService} from "../service/point/point.service";
import {Point} from "@core/models/Point";
import {HttpClient} from "@angular/common/http";
import {filter as _filter} from 'lodash';
import {combineLatest, Observable} from "rxjs";
import {RewardService} from "@app/feature/reward/service/reward.service";
import {map} from "rxjs/operators";


@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
})
export class UserDashboardComponent{
  public participantID: number = this.route.snapshot.paramMap.get("id") && parseInt(this.route.snapshot.paramMap.get("id"))
      || this.credentialsService.credentials?.participant_id
      || undefined

  public hasCompletedInitialSurvey$: Observable<boolean> = this.backendService.hasCompletedInitialSurvey$
  public surveys$: Observable<Survey[]> = this.backendService.participantSurvey$
  public point$: Observable<Point> = this.pointService.points$

  public isSyncInProgress$: Observable<boolean> = combineLatest(
      [this.backendService.isParticipantSurveyLoading$, this.rewardService.isPurchaseLoading$])
      .pipe(map(([isSurveyLoading, isPurchaseLoading]:[boolean, boolean]) => isSurveyLoading || isPurchaseLoading))

  public surveyCompleted$: Observable<Survey[]> = this.surveys$.pipe(
      map((surveys: Survey[]) => _filter(surveys, (survey: Survey) => survey.completed))
  )

  constructor(
    private readonly route: ActivatedRoute,
    public client: HttpClient,
    private readonly rewardService: RewardService,
    public backendService: BackendService,
    public credentialsService: CredentialsService,
    public pointService: PointService,
  ) {}

  public refreshAll(){
    this.backendService.participantSurveyRefresh$.next()
    this.rewardService.purchaseRefresh$.next()
  }
}

